module.exports = __webpack_public_path__ + "65b286af947c0d982ca01b40e1fcab38.ttf";